export default __webpack_public_path__ + "static/media/xero_page_five.156a1b62.svg";